import { UserDocumentCategory } from '@/features/admin/user-document-categories/userDocumentCategories.slice'
import { DropdownOption } from '@/componentsV1/BaseComponents/Dropdown'
import { adminApiAxios } from '@/api'

export const documentCategoryOptions = (
  documentCategories: { [key: string]: UserDocumentCategory },
  docType: string,
  isAdmin = false,
  internalNameArray: string[] = []
) => {
  if (!documentCategories) {
    return [] as DropdownOption<number>[]
  }
  let filteredDocumentCategories = Object.values(documentCategories)
    .filter(
      (cat) =>
        cat.type === docType &&
        ((isAdmin && !cat.archivedAt) || (!cat.archivedAt && !cat.isInternal))
    )
    .sort((a, b) => (a.title > b.title ? 1 : -1))
    .map((option: UserDocumentCategory) => ({
      value: option.id,
      text: option.title,
      internalName: option.internalName,
    }))
  if (internalNameArray.length > 0) {
    filteredDocumentCategories = filteredDocumentCategories.filter((cat) =>
      internalNameArray.includes(cat.internalName)
    )
  }
  return filteredDocumentCategories
}

export const downloadZipDocuments = async (documentIds: number[]) => {
  try {
    const url = '/finances/api/v1/admin/user_documents/zip'
    const res = await adminApiAxios.post(
      url,
      { documentIds },
      { responseType: 'arraybuffer' }
    )
    return res
  } catch (_) {
    return null
  }
}

export const compareArrays = <T>(arr1: T[], arr2: T[]) => {
  const set1 = new Set(arr1)
  const set2 = new Set(arr2)

  const newVals = arr2.filter((val) => !set1.has(val))
  const removedVals = arr1.filter((val) => !set2.has(val))

  return {
    newVals,
    removedVals,
  }
}
